import styled from "styled-components";
import { InviteLinkTopBg } from "@assets";
import { Button as AntButton } from "antd";

export const InviteLinkContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 16px;
	padding-bottom: 24px;
`;

export const InviteLinkTitle = styled.p`
	color: #E39401;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 1.5;

	@media screen and (max-width: 425px) {
		font-size: 17px;
	}

	@media screen and (max-width: 375px) {
		font-size: 15px;
	}
`;

export const CreateLinkButton = styled(AntButton)`
	padding: 0;
	margin: 0;
	width: calc(100% - 32px);
	height: 55px;

	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	svg {
		width: 24px;
	}
`;

export const TermsAndConditionsContainer = styled.div`
	padding: 16px;
	border-radius: 20px;
background: linear-gradient(180deg, #FEFBF1 0%, #FDF995 100%);
backdrop-filter: blur(25px);
	width: calc(100% - 32px);
	box-sizing: border-box;
`;

export const InviteLinkTerm = styled.p`
	text-align: center;
	margin: 0 auto;
	margin-bottom: 16px;

	color: #E39401;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */
`;

export const InviteLinkTerms = styled.span`
	margin: 0px;
	color: #4F4F4F;
	text-align: left;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */
`;





export const CreateLinkWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const TopImage = styled.img.attrs({
	alt: 'img',
	src: InviteLinkTopBg,
})`
margin-top: -70px;
	width: 100%;
	height: auto;
	aspect-ratio: 107 / 114;
`